import StatusLabel from '@/components/ui/status-label/status-label';
export default StatusLabel;
